import React, { useState } from 'react';
import { array, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'lodash';
import { Icon } from '@fiverr-private/fit';
import { r_plus } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import { EventTypes } from '../../../utils/events/types';
import eventsReporter from '../../../utils/events/reporter';
import { contextConnect } from '../../Context';
import MenuItem from './MenuItem';

import './index.scss';

const Menu = ({
    collections,
    resource,
    onCollectionClickedCallback,
    CreateCollectionModal
}) => {
    const [openModal, setOpenModal] = useState(false);

    const openModalWrapper = (e) => {
        e.stopPropagation();
        setOpenModal(true);

        eventsReporter.report(EventTypes.menu.createCollection.clicked);
    };

    const onCloseModal = () => {
        setOpenModal(false);
    };

    return (
        <div className="menu">
            <div className="coll-list-wrapper">
                {collections.length > 0 &&
                <ul className="coll-list">
                    {collections.map((collection) => (
                        <MenuItem key={collection.id}
                            collection={collection}
                            resource={resource}
                            onCollectionClickedCallback={onCollectionClickedCallback}/>
                    ))}
                </ul>
                }
                <button className="add-coll tbody-5"
                    onClick={openModalWrapper}>
                    <Icon className="create-icon">
                        {r_plus}
                    </Icon>
                    <I18n k="collect_package.create_list"/>
                </button>
            </div>
            {openModal && CreateCollectionModal &&
            <CreateCollectionModal resource={resource} onClose={onCloseModal}/>
            }
        </div>
    );
};

Menu.propTypes = {
    collections: array,
    resource: object,
    onCollectionClickedCallback: func,
    CreateCollectionModal: func
};

Menu.defaultProps = {
    onCollectionClickedCallback: _.noop
};

const mapStateToProps = ({ collections }) => ({ collections });

export { Menu };
export default compose(
    connect(mapStateToProps),
    contextConnect()
)(Menu);
